import { render, staticRenderFns } from "./ReportsHsqeAccidents.vue?vue&type=template&id=66b83d4d&"
import script from "./ReportsHsqeAccidents.vue?vue&type=script&lang=js&"
export * from "./ReportsHsqeAccidents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports